import { HttpTypes } from '@medusajs/types'
import { cn } from '@/utilities/ui'
import { bagelFatOne } from '@/utilities/fontImport'

interface SubCategoryMenuProps {
  subCategories: HttpTypes.StoreProductCategory[]
  selectedSubCategoryId: string | null
  onSelect: (subCategoryId: string | null) => void
}

const SubCategoryMenu: React.FC<SubCategoryMenuProps> = ({
  subCategories,
  selectedSubCategoryId,
  onSelect,
}) => {
  if (subCategories.length === 0) {
    return null
  }

  const tabClassName =
    'px-4 py-4 rounded-full lg:rounded-l-none font-bold text-base whitespace-nowrap transition-colors cursor-pointer'
  const activeTabClassName = 'bg-primary text-white'
  const inactiveTabClassName =
    'bg-light-pink text-black transition-all duration-300 hover:bg-linear-to-r hover:from-light-pink hover:via-primary hover:to-primary hover:text-white'

  return (
    <nav className="flex flex-wrap lg:flex-col gap-2 lg:gap-3 mb-6 lg:mb-0 lg:w-[50vh] mx-4 lg:mx-0 lg:pt-8 shrink-0 overflow-x-auto lg:overflow-visible">
      <button
        onClick={() => onSelect(null)}
        className={cn(
          tabClassName,
          bagelFatOne.className,
          selectedSubCategoryId === null ? activeTabClassName : inactiveTabClassName,
        )}
      >
        Tous
      </button>
      {subCategories.map((subCategory) => (
        <button
          key={subCategory.id}
          onClick={() => onSelect(subCategory.id)}
          className={cn(
            tabClassName,
            bagelFatOne.className,
            selectedSubCategoryId === subCategory.id ? activeTabClassName : inactiveTabClassName,
          )}
        >
          {subCategory.name}
        </button>
      ))}
    </nav>
  )
}

export default SubCategoryMenu
